import moment from 'moment';
import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { updateHostFailed, updateHostSuccessful } from '../actions';
import { CREATED, NO_CONTENT, OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* updateHost(action) {
  try {
    const {
      body,
      id,
    } = action.payload;

    const url = `${BACKEND_URL}/hosts/${id}`;
    const dataResponse = yield makeRequest(url, { ...body }, action, 'PUT', true);
    if (dataResponse.status === OK) {
      yield put(updateHostSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(updateHostFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(updateHostFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
